import { render, staticRenderFns } from "./PviMainPage.vue?vue&type=template&id=024a3198&scoped=true&"
import script from "./PviMainPage.vue?vue&type=script&lang=js&"
export * from "./PviMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a3198",
  null
  
)

export default component.exports